import HttpData from "@/http/data/http-data";

export interface ISessionPermissionFilterData {
    field: string;
    operator: string;
    values: unknown[];
}

export interface ISessionPermissionData {
    type: number;
    filters: ISessionPermissionFilterData[];
}

export interface ISessionAbilityData {
    namespace: string;
    resource: string|null;
    permissions: ISessionPermissionData[];
}

export interface ISessionData {
    username: string;
    full_name: string;
    token: string;
    roles: string[];
    abilities: ISessionAbilityData[];
}

export default class SessionData extends HttpData {
    public username: string;
    public full_name: string;
    public token: string;
    public roles: string[];
    public abilities: ISessionAbilityData[];

    constructor(data: ISessionData) {
        super();

        this.username = data.username;
        this.full_name = data.full_name;
        this.token = data.token;
        this.roles = data.roles;
        this.abilities = data.abilities;
    }
}